import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const DcDcConverterSizingCalculatorGuidePage = () => <DataDrivenGuidePage slug="guide-dcdc-converter-sizing" />;

export default DcDcConverterSizingCalculatorGuidePage;
